import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import store from '@/store'
import Layout from '@/layouts/Layout'
import Util from '@/common/utils/Util'
import SignSvc from '@/common/service/SignSvc'

/**
 * header, footer와 같은 layout 상태 update
 * @param meta.isFooter {Boolean} footer show 여부
 * @param meta.isHeader {Boolean} header show 여부
 * @param meta.titleName {String} header title String
 * @param meta.isMain {Boolean} main header show 여부
 *
 * */

const updateLayout = meta => {
  store.commit('layout/setLayout', {
    isHeader: meta.isHeader,
    isNav: meta.isNav,
    isFooter: meta.isFooter,
    isMain: meta.isMain
  })
}
let nowPath = ''
const fnBeforeCheckEnter = (to, from, next) => {
  const authorization = to.query.authorization
  nowPath = to.path
  if (!Util.isEmpty(authorization)) {
    const params = {}
    params.authorization = authorization
    SignSvc.adminLogin(params).then(res => {
      let authToken = res.headers['authorization']
      let userData = res.data.entity
      store.commit('user/storeLogin', {accessToken: authToken, userData: JSON.stringify(userData)})
    })
  }
  if (nowPath === '/intro') {
    next({
      path: '/main'
    })
  }
}

// /index or /main 이동 체크
const fnBeforeEnter = (to, from, next) => {
  // 회원정보 등록 여부
  fnBeforeCheckEnter(to, from, next)
}

// 접속 유지 24시간 이후 자동 제거
const loginCheck = async (to, from, next) => {
  const user = store.getters['user/getUserData']
  if (!Util.isEmpty(user)) {
    const res = await SignSvc.fetchUser()
    if (res.code === -9997) {
      await SignSvc.logout()
      next()
    }
    const loginDate = new Date(res.entity.loginDate).getTime()
    const now = new Date().getTime()
    const sec = parseInt(now - loginDate) / 1000
    const hour = parseInt(sec / 60 / 60)
    if (Number(hour) >= 24) {
      await SignSvc.logout()
      next({path: '/main'})
      return false
    } else {
      next()
    }
  }
  next()
}

const router = new Router({
  linkActiveClass: 'on',
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // 원하는 위치로 돌아가기
    return new Promise(resolve => {
      setTimeout(() => {
        if (to.hash === '#ma') {
          return false
        }
        if (savedPosition) {
          resolve(savedPosition)
        }
        resolve({ x: 0, y: 0 })
      }, 100)
    })
  },
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/main',
      children: [
        {
          path: '/intro',
          name: 'intro',
          beforeEnter: fnBeforeEnter
        },
        {
          description: '메인',
          path: '/main',
          name: 'main-index',
          meta: {
            isHeader: true,
            isFooter: true,
            isMain: true
          },
          component: () => import('@/pages/main/index'),
          beforeEnter: loginCheck
        },
        {
          description: '로그인',
          path: '/sign/in',
          name: 'sign-in-index',
          meta: {
            isHeader: true,
            isFooter: true,
            isMain: true
          },
          component: () => import('@/pages/sign/in/index')
        },
        {
          description: '회원가입 step1',
          path: '/sign/up/step1',
          name: 'sign-up-step1-index',
          meta: {
            isHeader: true,
            isFooter: true,
            isMain: true
          },
          component: () => import('@/pages/sign/up/step1/index')
        },
        {
          description: '회원가입 step2',
          path: '/sign/up/step2',
          name: 'sign-up-step2-index',
          meta: {
            isHeader: true,
            isFooter: true,
            isMain: true
          },
          component: () => import('@/pages/sign/up/step2/index')
        },
        {
          description: '아이디찾기',
          path: '/sign/find/id',
          name: 'sign-find-id-index',
          meta: {
            isHeader: true,
            isFooter: true,
            isMain: true
          },
          component: () => import('@/pages/sign/find/id/index')
        },
        {
          description: '비밀번호찾기 step1',
          path: '/sign/find/password/step1',
          name: 'sign-find-password-step1-index',
          meta: {
            isHeader: true,
            isFooter: true,
            isMain: true
          },
          component: () => import('@/pages/sign/find/password/step1/index')
        },
        {
          description: '비밀번호찾기 step2',
          path: '/sign/find/password/step2',
          name: 'sign-find-password-step2-index',
          meta: {
            isHeader: true,
            isFooter: true,
            isMain: true
          },
          component: () => import('@/pages/sign/find/password/step2/index')
        },
        {
          description: '협회소개',
          path: '/about',
          name: 'about-index',
          meta: {
            isHeader: true,
            isFooter: true,
            isMain: false
          },
          component: () => import('@/pages/about/index'),
          children: [
            {
              description: '인사말',
              path: '/about/greeting',
              name: 'about-greeting-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/about/greeting/index')
            },
            {
              description: '협회 연혁',
              path: '/about/history',
              name: 'about-history-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/about/history/index')
            },
            {
              description: '임원 소개',
              path: '/about/exctv',
              name: 'about-exctv-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/about/exctv/index')
            },
            {
              description: '조직도',
              path: '/about/orgnz-chart',
              name: 'about-orgnz-chart-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/about/orgnz-chart/index')
            },
            {
              description: '찾아오는 길',
              path: '/about/road',
              name: 'about-road-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/about/road/index')
            },
            {
              description: 'CI',
              path: '/about/ci',
              name: 'about-ci-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/about/ci/index')
            }
          ]
        },
        {
          description: '위생 교육',
          path: '/hygn',
          name: 'hygn-index',
          meta: {
            isHeader: true,
            isFooter: true,
            isMain: false
          },
          component: () => import('@/pages/hygn/index'),
          children: [
            {
              description: '식품 위생 교육 안내',
              path: '/hygn/notice',
              name: 'hygn-notice-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/hygn/notice/index')
            },
            {
              description: '협회 연혁',
              path: '/hygn/agency',
              name: 'hygn-agency-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/hygn/agency/index')
            }
          ]
        },
        {
          description: '외식 경영 관리사',
          path: '/manager',
          name: 'manager-index',
          meta: {
            isHeader: true,
            isFooter: true,
            isMain: false
          },
          component: () => import('@/pages/manager/index'),
          children: [
            {
              description: '외식 경영 관리사 안내',
              path: '/manager/info',
              name: 'manager-info-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/manager/info/index')
            },
            {
              description: '교육 신청',
              path: '/manager/edu',
              name: 'manager-edu-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/manager/edu/index'),
              children: [
                {
                  description: '교육 신청',
                  path: '/manager/edu/apply',
                  name: 'manager-edu-apply-index',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () => import('@/pages/manager/edu/apply/index')
                },
                {
                  description: '교육 신청 상세',
                  path: '/manager/edu/apply/view',
                  name: 'manager-edu-apply-view',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () => import('@/pages/manager/edu/apply/view')
                },
                {
                  description: '교육 신청 form',
                  path: '/manager/edu/apply/write',
                  name: 'manager-edu-apply-write-index',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () =>
                    import('@/pages/manager/edu/apply/write/index')
                },
                {
                  description: '교육 신청 완료',
                  path: '/manager/edu/apply/done',
                  name: 'manager-edu-apply-done-index',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () =>
                    import('@/pages/manager/edu/apply/done/index')
                },
                {
                  description: '접수 확인 및 취소',
                  path: '/manager/edu/register',
                  name: 'manager-edu-register-index',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () => import('@/pages/manager/edu/register/index')
                },
                {
                  description: '접수 확인 및 취소 상세',
                  path: '/manager/edu/register/view',
                  name: 'manager-edu-register-view',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () => import('@/pages/manager/edu/register/view')
                }
              ]
            },
            {
              description: '시험 신청',
              path: '/manager/exam',
              name: 'manager-exam-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/manager/exam/index'),
              children: [
                {
                  description: '시험 신청',
                  path: '/manager/exam/apply',
                  name: 'manager-exam-apply-index',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () => import('@/pages/manager/exam/apply/index')
                },
                {
                  description: '시험 신청 상세',
                  path: '/manager/exam/apply/view',
                  name: 'manager-exam-apply-view',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () => import('@/pages/manager/exam/apply/view')
                },
                {
                  description: '시험 신청',
                  path: '/manager/exam/apply/write',
                  name: 'manager-exam-apply-write-index',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () =>
                    import('@/pages/manager/exam/apply/write/index')
                },
                {
                  description: '시험 신청 완료',
                  path: '/manager/exam/apply/done',
                  name: 'manager-exam-apply-done-index',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () =>
                    import('@/pages/manager/exam/apply/done/index')
                },
                {
                  description: '접수 확인 및 취소',
                  path: '/manager/exam/register',
                  name: 'manager-exam-register-index',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () => import('@/pages/manager/exam/register/index')
                },
                {
                  description: '접수 확인 및 취소 상세',
                  path: '/manager/exam/register/view',
                  name: 'manager-exam-register-view',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () => import('@/pages/manager/exam/register/view')
                },
                {
                  description: '수험표 출력',
                  path: '/manager/exam/admission',
                  name: 'manager-exam-admission-index',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () =>
                    import('@/pages/manager/exam/admission/index')
                },
                {
                  description: '공지 사항',
                  path: '/manager/exam/notice',
                  name: 'manager-exam-notice-index',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () => import('@/pages/manager/exam/notice/index')
                },
                {
                  description: '공지 사항 상세',
                  path: '/manager/exam/notice/view',
                  name: 'manager-exam-notice-view',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () => import('@/pages/manager/exam/notice/view')
                },
                {
                  description: '자격증 발급(재발급)',
                  path: '/manager/exam/certificate',
                  name: 'manager-exam-certificate-index',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () =>
                    import('@/pages/manager/exam/certificate/index')
                },
                {
                  description: '합격자 조회',
                  path: '/manager/exam/pass',
                  name: 'manager-exam-pass-index',
                  meta: {
                    isHeader: true,
                    isFooter: true,
                    isMain: false
                  },
                  component: () => import('@/pages/manager/exam/pass/index')
                }
              ]
            }
          ]
        },
        {
          description: '회원공간',
          path: '/space',
          name: 'space-index',
          meta: {
            isHeader: true,
            isFooter: true,
            isMain: false
          },
          component: () => import('@/pages/space/index'),
          children: [
            {
              description: '회원 게시판',
              path: '/space/board',
              name: 'space-board-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/space/board/index')
            },
            {
              description: '회원 게시판 상세',
              path: '/space/board/view',
              name: 'space-board-view',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/space/board/view')
            },
            {
              description: '회원 게시판 글쓰기',
              path: '/space/board/write',
              name: 'space-board-write-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/space/board/write/index')
            },
            {
              description: '회원 홍보관',
              path: '/space/promotion',
              name: 'space-promotion-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/space/promotion/index')
            },
            {
              description: '회원 홍보관 상세',
              path: '/space/promotion/view',
              name: 'space-promotion-view',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/space/promotion/view')
            },
            {
              description: '회원 홍보관 글쓰기',
              path: '/space/promotion/write',
              name: 'space-promotion-write-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/space/promotion/write/index')
            },
            {
              description: '배너 안내',
              path: '/space/banner',
              name: 'space-banner-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/space/banner/index')
            }
          ]
        },
        {
          description: '소식 알림',
          path: '/news',
          name: 'news-index',
          meta: {
            isHeader: true,
            isFooter: true,
            isMain: false
          },
          component: () => import('@/pages/news/index'),
          children: [
            {
              description: '협회 소식',
              path: '/news/asctn',
              name: 'news-asctn-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/news/asctn/index')
            },
            {
              description: '협회 소식 상세',
              path: '/news/asctn/view',
              name: 'news-asctn-view-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/news/asctn/view')
            },
            {
              description: '공지사항',
              path: '/news/notice',
              name: 'news-notice-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/news/notice/index')
            },
            {
              description: '공지사항 상세',
              path: '/news/notice/view',
              name: 'news-notice-view-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/news/notice/view')
            },
            {
              description: '외식 산업 뉴스',
              path: '/news/kfood',
              name: 'news-kfood-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/news/kfood/index')
            },
            {
              description: '자료실',
              path: '/news/data',
              name: 'news-data-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/news/data/index')
            },
            {
              description: '자료실 상세',
              path: '/news/data/view',
              name: 'news-data-view-index',
              meta: {
                isHeader: true,
                isFooter: true,
                isMain: false
              },
              component: () => import('@/pages/news/data/view')
            }
          ]
        }
        // 사용하지 않는 페이지 주석
        // {
        //   description: '이용 안내',
        //   path: '/terms',
        //   name: 'terms-index',
        //   meta: {
        //     isHeader: true,
        //     isFooter: true,
        //     isMain: false
        //   },
        //   component: () => import('@/pages/terms/index'),
        //   children: [
        //     {
        //       description: '이용 약관',
        //       path: '/terms/use',
        //       name: 'terms-use-index',
        //       meta: {
        //         isHeader: true,
        //         isFooter: true,
        //         isMain: false
        //       },
        //       component: () => import('@/pages/terms/use/index')
        //     },
        //     {
        //       description: '개인정보처리방침',
        //       path: '/terms/private',
        //       name: 'terms-private-index',
        //       meta: {
        //         isHeader: true,
        //         isFooter: true,
        //         isMain: false
        //       },
        //       component: () => import('@/pages/terms/private/index')
        //     },
        //     {
        //       description: '제3자 마케팅 활용 동의서',
        //       path: '/terms/marketing',
        //       name: 'terms-marketing-index',
        //       meta: {
        //         isHeader: true,
        //         isFooter: true,
        //         isMain: false
        //       },
        //       component: () => import('@/pages/terms/marketing/index')
        //     }
        //   ]
        // }
      ]
    }
  ]
})

// 로그인 권한 접근 가능 path
const paths = [
  '/manager/edu/apply',
  '/manager/edu/register',
  '/manager/exam/apply',
  '/manager/exam/register',
  '/manager/exam/admission',
  '/manager/exam/certificate',
  '/manager/exam/pass',
  '/space/board',
  '/space/promotion'
]

router.beforeEach((to, from, next) => {
  const path = to.path
  const user = store.getters['user/getUserData']
  if (Util.isEmpty(user)) {
    // 비회원일경우 이용불가 체크
    if (paths.indexOf(path) > -1) {
      alert('로그인시 접근가능합니다.')
      return next(false)
    }
  }
  let meta = to.meta
  updateLayout(meta)
  return next()
})

window.fnCloseModal = () => {
  let isModal = store.state.layout.modal.isModal
  if (isModal) {
    store.commit('layout/setIsShowModal', { isShow: false })
    setTimeout(() => {
      store.commit('layout/setModal', { isModal: false, modalName: '' })
    }, 200)
    return true
  }
  return false
}
window.fnCloseModalAlert = () => {
  let isModalAlert = store.state.layout.modalAlert.isModalAlert
  if (isModalAlert) {
    store.commit('layout/setIsShowModalAlert', { isShowAlert: false })
    setTimeout(() => {
      store.commit('layout/setModalAlert', {
        isModalAlert: false,
        modalAlertName: ''
      })
    }, 200)
    return true
  }
  return false
}

export default router
